import axios from "axios";

//state
export var insightState = {
  insights: [],
  topics: [],
  commentcount: [],
  insights_all: [],
  topics_all: [],
  commentcount_all: [],
  uuids: [],
  uuids_response: [],
  status_uuid: "",
  status_uuids_response: "",

  status_insight: "",
  status_topic: "",
  status_category_topic: "",
  status_comment: "",
  status_analyzeinsightfirst: "",
  status_analyzeinsightthird: "",
  status_analyzeinsightfourth: "",
  status_analyzeinsightfifth: "",
  analyzeinsightfirst: [],
  analyzeinsightthird: [],
  analyzeinsightfourth: [],
  analyzeinsightfifth: [],
  analyzeinsightfirst_all: [],
  analyzeinsightthird_all: [],
  analyzeinsightfourth_all: [],
  analyzeinsightfifth_all: [],
  quiz_stat_overview: [],
  getQuizstatOverview: [],

  starRating: [],
  category_topic: [],


};

//getters
export var insightGetters = {
  //funciones para optener informacion del state
  getstatIds: state => state.uuids,
  getuuidResponse: state => state.uuids_response,

  getdatastudioSentiment: state => state.insights,
  getdatastudioSentimentStarRating: state => state.starRating,
  getdatastudioTopics: state => state.topics,
  getCategoryNameTopics: state => state.category_topic,
  getcommentCount: state => state.commentcount,
  getanalyzeInsightFirst: state => state.analyzeinsightfirst,
  getanalyzeInsightThird: state => state.analyzeinsightthird,
  getanalyzeInsightFourth: state => state.analyzeinsightfourth,
  getanalyzeInsightFifth: state => state.analyzeinsightfifth,

  getdatastudioSentimentAll: state => state.insights_all,
  getdatastudioTopicsAll: state => state.topics_all,
  getcommentCountAll: state => state.commentcount_all,
  getanalyzeInsightFirstAll: state => state.analyzeinsightfirst_all,
  getanalyzeInsightThirdAll: state => state.analyzeinsightthird_all,
  getanalyzeInsightFourthAll: state => state.analyzeinsightfourth_all,
  getanalyzeInsightFifthAll: state => state.analyzeinsightfifth_all,
  getQuizstatOverview: state => state.quiz_stat_overview,
  // respustasDelete:state=>state.uuids,

};

//actions
export var insightActions = {
  async getdatastudioSentiment({ commit }, partner_ids) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.datastudiosentiment", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'location_name', ('location_id',['id','locationName',('partner_id',['id','name'])]),'score_tag', 'create_time', 'star_rating','comment', 'comment_eng']"
        },
        params: {
          limit: 0,
          args: `[["comment", "!=", "false",],["score_tag", "!=", "false",],["location_id.partner_id.id", "in", [${partner_ids}]]]`
          // args: `[["comment", "!=", "false",],["score_tag", "!=", "false",],["location_id.partner_id.name", "=", "Apache",],]`
        }
      })
      .then(res => {
        var insight = res.data;
        commit("insight_success", insight);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async getdatastudioSentimentStarRating({ commit }, partner_ids) {

    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.datastudiosentiment", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['star_rating','score_tag', ('location_id',['id','locationName','city','description' , ('partner_id',['id','name'])])]"
        },
        params: {
          limit: 0,
          args: `[["comment", "!=", "false",],["score_tag", "!=", "false",],["location_id.partner_id.id", "in", [${partner_ids}]]]`
          // args: `[["comment", "!=", "false",],["score_tag", "!=", "false",],["location_id.partner_id.name", "=", "Apache",],]`
        }
      })
      .then(res => {
        var starRating = res.data;
        console.log("starRating", res.data);
        commit("insight_starrating_success", starRating);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async getdatastudioSentimentAll({ commit }) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.datastudiosentiment", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'location_name', ('location_id',['id','locationName',('partner_id',['id','name'])]),'score_tag', 'create_time', 'star_rating','comment', 'comment_eng']"
        },
        params: {
          limit: 0,
          args: `[["comment", "!=", "false",],["score_tag", "!=", "false",],]`
        }
      })
      .then(res => {
        var insight = res.data;
        commit("insight_success_all", insight);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async getdatastudioTopics({ commit }, partner_ids) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.datastudiotopics", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'topic_form','category_name',('category_id',['id','name']),'location_name', ('location_id',['id','locationName','city', 'description',('partner_id',['id', 'name'])]), 'score_tag', 'create_time', 'star_rating']",

        },
        params: {
          limit: 0,
          args: `[["category_name", "!=", "false",],["location_id.partner_id.id", "in", [${partner_ids}]]]`
          // args: `[["category_name", "!=", "false",],["location_id.partner_id.name", "=", "Apache",],]`

        }
      })
      .then(res => {
        var topic = res.data;
        commit("topic_success", topic);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async getCategoryNameTopics({ commit },partner_ids) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.datastudiotopics", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['topic_form','category_name',('location_id',['id','locationName','city', 'description',('partner_id',['id', 'name'])]),]",

        },
        params: {
          limit: 0,
          args: `[["category_name", "!=", "false",], ["location_id.partner_id.id", "in", [${partner_ids}]]]`
          // args: `[["category_name", "!=", "false",],["location_id.partner_id.name", "=", "Apache",],]`

        }
      })
      .then(res => {
        var category_name = res.data;
        commit("category_name_success", category_name);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async getdatastudioTopicsAll({ commit }) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.datastudiotopics", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'topic_form','category_name',('category_id',['id','name']),'location_name', ('location_id',['id','locationName',('partner_id',['id', 'name'])]), 'score_tag', 'create_time', 'star_rating']",

        },
        params: {
          limit: 0,
          args: `[["category_name", "!=", "false",],]`

        }
      })
      .then(res => {
        var topic = res.data;
        commit("topic_success_all", topic);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async getcommentCount({ commit }) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.datastudiosentiment", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'location_name',('location_id',['id','locationName','city', 'description',('partner_id',['id','name'])]),'score_tag','comment']"
        },
        params: {
          limit: 0,


        }
      })
      .then(res => {
        var commentcount = res.data;
        commit("comment_success", commentcount);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async getanalyzeInsightFirst({ commit }, partner_ids) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.analyze_insight_first", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', ('location_id',['id','locationName',('partner_id',['id','name']), 'city','description']),'location_name',('partner_id',['id','name']),'partner_name','create_time','score_tag', 'count']"
        },
        params: {
          limit: 0,
          args: `[["location_id.partner_id.id", "in", [${partner_ids}]]]`

        }
      })
      .then(res => {
        var commentcount = res.data;
        console.log("getanalyzeInsightFirst ::: ", res.data);
        commit("analyzeinsightfirst_success", commentcount);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async getanalyzeInsightThird({ commit },partner_ids) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.analyze_insight_third", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'create_time', ('location_id',['id','locationName', 'city','description']),'location_name',('partner_id',['id','name']),'partner_name',('page_id',['id','name']),'page_name','category_name','score_tag', 'avg_star_rating']"
        },
        params: {
          limit: 0,
          args: `[["category_name", "!=", "false",], ["location_id.partner_id.id", "in", [${partner_ids}]]]`
          // args: `[["category_name", "!=", "false",],["partner_name", "=", "Apache",]]` 

        }
      })
      .then(res => {
        var commentcount = res.data;
        commit("analyzeinsightthird_success", commentcount);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },  
  async getanalyzeInsightFifth({ commit },partner_ids) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.analyze_insight_fifth", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', ('location_id',['id','locationName', 'city','description']),'location_name',('page_id',['id','name']),('partner_id',['id','name']),'partner_name','create_time','score_tag', 'form', 'count']"
        },
        params: {
          limit: 150,
          args: `[["location_id.partner_id.id", "in", [${partner_ids}]]]`
        }
      })
      .then(res => {
        var commentcount = res.data;
        commit("analyzeinsightfifth_success", commentcount);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async getanalyzeInsightFourth({ commit }, partner_ids) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.analyze_insight_fourth", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'category_name', ('page_id',['id','name']),('location_id',['id','locationName', 'city','description']),'location_name',('partner_id',['id','name']),'partner_name','create_time','score_tag', 'count']"
        },
        params: {
          limit: 0,
          args: `[["category_name", "!=", "false",], ["location_id.partner_id.id", "in", [${partner_ids}]]]`
          // args: `[["category_name", "!=", "false",],["partner_name", "=", "Apache",]]`                   
        }
      })
      .then(res => {
        var commentcount = res.data;
        // console.log("res.data", res.data);      
        commit("analyzeinsightfourth_success", commentcount);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async getanalyzeInsightFirstAll({ commit }) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.analyze_insight_first", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', ('location_id',['id','locationName',('partner_id',['id','name']), 'city','description']),'location_name',('partner_id',['id','name']),'partner_name','create_time','score_tag', 'count']"
        },
        params: {
          limit: 0,
          // args: `[["partner_name", "=", "Apache",],]`

        }
      })
      .then(res => {
        var commentcount = res.data;
        commit("analyzeinsightfirst_success_all", commentcount);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async getanalyzeInsightThirdAll({ commit }) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.analyze_insight_third", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'create_time', ('location_id',['id','locationName', 'city','description']),'location_name',('partner_id',['id','name']),'partner_name',('page_id',['id','name']),'page_name','category_name','score_tag', 'avg_star_rating']"
        },
        params: {
          limit: 0,
          args: `[["category_name", "!=", "false",]]`

        }
      })
      .then(res => {
        var commentcount = res.data;
        commit("analyzeinsightthird_success_all", commentcount);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async getanalyzeInsightFifthAll({ commit }) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.analyze_insight_fifth", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', ('location_id',['id','locationName', 'city','description']),'location_name',('page_id',['id','name']),('partner_id',['id','name']),'partner_name','create_time','score_tag', 'form', 'count']"
        },
        params: {
          limit: 250,
          // args: `[["partner_name", "=", "Apache",],]`                        
        }
      })
      .then(res => {
        var commentcount = res.data;
        commit("analyzeinsightfifth_success_all", commentcount);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  
  async getanalyzeInsightFourthAll({ commit }) {
    commit("insight_request");
    await this._vm.$http
      .get("/apache/rest_api/brand_whisper.analyze_insight_fourth", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'category_name', ('page_id',['id','name']),('location_id',['id','locationName', 'city','description']),'location_name',('partner_id',['id','name']),'partner_name','create_time','score_tag', 'count']"
        },
        params: {
          limit: 0,
          // args: `[["category_name", "!=", "false",],["partner_name", "=", "Apache",]]`
        }
      })
      .then(res => {
        var commentcount = res.data;
        // console.log("res.data", res.data);      
        commit("analyzeinsightfourth_success_all", commentcount);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async getstatIds({ commit }, item_id) {
    commit("insight_request");
    console.log("item_id :::::::::", item_id);
    await this._vm.$http
      .get("/apache/rest_api/apache.quiz.stat_uuid", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            '["id","create_date", "uuid", ("quiz_id",["id","name"])]'
        },
        params:{
          limit:0,
          args:`[['quiz_id.id','=?', ${item_id}],]`
        }
      })
      .then(res => {
        var uuids = res.data;
        if (uuids == "") {
          uuids = []
        }
        commit("uuids_success", uuids);
        return res;


      })
      .catch(err => {
        commit("insight_error")
        return err;
      });
  },
  async getuuidResponse({ commit }, payload) {
    commit("insight_request");
    console.log("payload::::: ", payload);
    var {
      quiz_id,
      uuid
    } = payload;
    await this._vm.$http
      .get("/apache/rest_api/apache.quiz.stat", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            '["id","create_date","question","question_text", "answer"]'
        },
        params: {
          // limit:0,
          // args : "[('uuid,'=','b9402f29-c84e-4766-ba49-c513909f2376')]"
          // quiz_id: `${quiz_id}`,
          // args: `${uuid}`
          args: `[['uuid','=?','${uuid}'],['quiz_id','=?',${quiz_id}]]`


        }
      })
      .then(res => {
        var uuids_response = res.data;
        console.log("uuids_response ::::::::: ", uuids_response);
        if (uuids_response == "") {
          uuids_response = []
        }
        commit("uuids_response_success", uuids_response);
        return res;


      })
      .catch(err => {
        commit("insight_error")
        return err;
      });
  },
  async getQuizstatOverview11({ commit }, id) {
    commit("insight_request");
    await this._vm.$http
      .get(`/apache/rest_api/apache.quiz.stat_overview/`, {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'started','answers', 'finished','avg_time','create_date',('quiz_id',['id','name']),  ('partner_id',['id','name']),('location_id',['id','locationName', 'city','description'])]"
          // "['id', 'started','answers', 'finished','avg_time', 'create_date', quiz_id, ('partner_id',['id','name'],('location_id',['id','locationName',('partner_id',['id','name'])])]"
        },
        params: {
          limit: 0,
          // args: '["quiz_id.id","=", ${id},]'                   
          // args: `[["category_name", "!=", "false",],["partner_name", "=", "Apache",]]`                   
        }
      })
      .then(res => {
        var commentcount = res.data;
        // console.log("res.data", res.data);      
        commit("getQuizstatOverview", commentcount);
        return res;
      })
      .catch(err => {
        commit("insight_error");
        return err;
      });
  },
  async respustasDelete12({ commit, state }, payload) {
        commit("insight_request");
        var {
          quiz_id,
          uuids
        } = payload;

        //console.log("review_id in getreviewDelete :::: ", review_id);
        await this._vm.$http
            .get("/apache/rest_api/apache.quiz/execute/delete_uuid_stats", {
                headers: {
                    //"X-Odoo-dbfilter": "apachev1",
                },
                params: {
                    ids: `[${quiz_id}]`,
                    args: `['uuids','=?',[${uuids}]]`
                }

            })
            .then(res => {
                //console.log("check res in replywizard delete", res);
                if (res.success == true) {
                    commit("insight_delete_success", res);
                    var uuids= state.uuids;
                    return uuids;

                } else {
                    commit("insight_error");
                }
            })
            .catch(err => {
                //console.log("err",err);
                commit("insight_error");
                return err;
            });
    },
};
//mutations

export var insightMutations = {
  insight_request(state) {
    state.status_insight = "loading";
  },
  insight_success(state, payload) {
    state.status_insight = "success";
    state.insights = payload;
  },
  insight_success_all(state, payload) {
    state.status_insight = "success";
    state.insights_all = payload;
  },
  topic_success_all(state, payload) {
    state.status_topic = "success";
    state.topics_all = payload;
  },
  comment_success_all(state, payload) {
    state.status_comment = "success";
    state.commentcount_all = payload;
  },
  analyzeinsightfirst_success_all(state, payload) {
    state.status_analyzeinsightfirst = "success";
    state.analyzeinsightfirst_all = payload;
  },
  analyzeinsightthird_success_all(state, payload) {
    state.status_analyzeinsightthird = "success";
    state.analyzeinsightthird_all = payload;
  },
  analyzeinsightfourth_success_all(state, payload) {
    state.status_analyzeinsightfourth = "success";
    state.analyzeinsightfourth_all = payload;
  },
  analyzeinsightfourth_success_all(state, payload) {
    state.status_analyzeinsightfifth = "success";
    state.analyzeinsightfifth_all = payload;
  },
  insight_starrating_success(state, payload) {
    state.status_insight_starrating = "success";
    state.starRating = payload;
  },
  topic_success(state, payload) {
    state.status_topic = "success";
    state.topics = payload;
  },
  category_name_success(state, payload) {
    state.status_category_topic = "success";
    state.category_topic = payload;
  },
  comment_success(state, payload) {
    state.status_comment = "success";
    state.commentcount = payload;
  },
  analyzeinsightfirst_success(state, payload) {
    state.status_analyzeinsightfirst = "success";
    console.log("analyzeinsightfirst_success 111::::: ", payload, state.analyzeinsightfirst);
    state.analyzeinsightfirst = payload;
  },
  analyzeinsightthird_success(state, payload) {
    state.status_analyzeinsightthird = "success";
    state.analyzeinsightthird = payload;
  },
  analyzeinsightfourth_success(state, payload) {
    state.status_analyzeinsightfourth = "success";
    state.analyzeinsightfourth = payload;
  },
  analyzeinsightfifth_success(state, payload) {
    state.status_analyzeinsightfifth = "success";
    state.analyzeinsightfifth = payload;
  },
  uuids_success(state, payload) {
    state.status_uuid = "success";
    state.uuids = payload;
  },
  uuids_response_success(state, payload) {
    state.status_uuids_response = "success";
    state.uuids_response = payload;
  },
  insight_delete_success(state, payload) {
    state.status_uuids_response = "success";
    state.uuids_response = payload;
  },
  getQuizstatOverview(state, payload) {
    state.quiz_stat_overview = "success";
    const quizStat = payload;
    state.quiz_stat_overview = quizStat;
  },
  insight_error(state) {
    state.status_insight = "error";
  }
};
